import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaDealCommentContainerModel } from "../../../../../../models/aggregates/sfa/deal/SfaDealCommentContainer.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
    providedIn: 'root'
    })
    export class SfaDealCommentService extends BaseApiTemplateService<SfaDealCommentContainerModel> {

    readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deal-comments';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deal-comments';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.SFA_MODULE_PREFIX + 'deal-comments';
        this.httpClient = http;
    }
    }